var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVectorfacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7002 12.25H12.4502V1.75H1.9502V12.25H7.2002V8.5H5.7002V7H7.2002V5.7595C7.2002 4.75675 7.30519 4.393 7.5002 4.02625C7.69228 3.66339 7.98917 3.36677 8.3522 3.175C8.6387 3.02125 8.99494 2.929 9.61744 2.88925C9.86419 2.8735 10.1837 2.893 10.5759 2.94925V4.37425H10.2002C9.51245 4.37425 9.2282 4.4065 9.05869 4.49725C8.95755 4.54927 8.87521 4.63161 8.82319 4.73275C8.7332 4.90225 8.7002 5.07025 8.7002 5.75875V7H10.5752L10.2002 8.5H8.7002V12.25ZM1.2002 0.25H13.2002C13.3991 0.25 13.5899 0.329018 13.7305 0.46967C13.8712 0.610322 13.9502 0.801088 13.9502 1V13C13.9502 13.1989 13.8712 13.3897 13.7305 13.5303C13.5899 13.671 13.3991 13.75 13.2002 13.75H1.2002C1.00128 13.75 0.810517 13.671 0.669865 13.5303C0.529213 13.3897 0.450195 13.1989 0.450195 13V1C0.450195 0.801088 0.529213 0.610322 0.669865 0.46967C0.810517 0.329018 1.00128 0.25 1.2002 0.25Z",
    fill: "#B8B8B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorfacebook);
export default __webpack_public_path__ + "static/media/Vectorfacebook.bc5694726d3c3cbd972fc74496475527.svg";
export { ForwardRef as ReactComponent };